export default window.bootstrapvalidation = function bootstrapvalidation() {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName("needs-validation");
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
            "submit",
            function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                    false;
                }
                form.classList.add("was-validated");
            },
            false
        );
    });
};

(function () {
    "use strict";
    window.addEventListener(
        "load",
        function () {
            bootstrapvalidation();
        },
        false
    );
})();
